import { render, staticRenderFns } from "./MessagesLogHeader.vue?vue&type=template&id=761d619f&scoped=true&"
import script from "./MessagesLogHeader.vue?vue&type=script&lang=js&"
export * from "./MessagesLogHeader.vue?vue&type=script&lang=js&"
import style0 from "./MessagesLogHeader.vue?vue&type=style&index=0&id=761d619f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761d619f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBadge,VBtn,VCardText,VIcon,VTooltip})
